export default __webpack_public_path__ + "static/media/boy10.107613b9.jpg";